import { map as rxjsmap } from 'rxjs';


import { Injectable } from '@angular/core';
import { RegistrationList } from 'src/app/kuba/Registration/models/registration-list';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { BaseServices } from './../../kuba.services';
import { RegistrationType } from './../models/registration-type';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class RegistrationServices {
  constructor(private http: HttpClient) {}

  // List all registrations
  getAllByEach(id: number, key: string) {
    return this.http
      .get(
        `${environment.BASE_URL}/${BaseServices.apiRoute(
          key
        )}/registration/${id}`
      ).pipe(rxjsmap((result: any) => result));
  }

  // add
  addRegistration(register: RegistrationList, key: number) {
    return this.http
      .post(
        `${environment.BASE_URL}/${BaseServices.apiRoute(key)}/registration`,
        register
      ).pipe(rxjsmap(result => result));
  }

  // updating registration list
  updateRegistration(ExistingMember: RegistrationList, key: number) {
    return this.http
      .put(
        `${environment.BASE_URL}/${BaseServices.apiRoute(key)}/registration`,
        ExistingMember
      ).pipe(rxjsmap(result => result));
  }

  // list all document
  getAllDocById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/registration/' + id).pipe(rxjsmap(result => result));
  }

  // delete equipment from list
  deleteDoc(documentIds: number[]) {
    return this.http
      .delete(environment.BASE_URL + '/registration-document', {
        body: documentIds
      }).pipe(rxjsmap(result => result));
  }

  // edit register
  getRegisterById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/registration/' + id).pipe(rxjsmap((result: any) => result));
  }

  // add registration to list
  add(data): Observable<any> {
    let body = JSON.stringify(data);
    return this.http
      .post(environment.BASE_URL + '/registration', body).pipe(rxjsmap(res => res));
  }

  // updating registration list
  update(ExistingMember: RegistrationList) {
    return this.http
      .put(environment.BASE_URL + '/registration', ExistingMember).pipe(rxjsmap(result => result));
  }

  // Delete registration from list
  deleteRegistration(Id) {
    return this.http
      .delete(environment.BASE_URL + '/registration/' + Id).pipe(rxjsmap(result => result));
  }

  // bind registration type
  getAllByRegType(id: number, key: string) {
    return this.http
      .get(
        `${environment.BASE_URL}/${BaseServices.apiRoute(
          key
        )}/registrationtype/${id}`
      ).pipe(rxjsmap((result: any) => result));
  }

  // update registration Type
  updateRegType(existingCategory: RegistrationType, key: number) {
    return this.http
      .put(
        `${environment.BASE_URL}/${BaseServices.apiRoute(
          key
        )}/registrationtype`,
        existingCategory
      ).pipe(rxjsmap(result => result));
  }

  // adding registration Type
  createRegType(newCategory: RegistrationType, key: number) {
    return this.http
      .post(
        `${environment.BASE_URL}/${BaseServices.apiRoute(
          key
        )}/registrationtype`,
        newCategory
      ).pipe(rxjsmap(result => result));
  }

  // delete registration Type
  deleteRegType(Id: number) {
    let result: boolean;
    return this.http.delete(
      environment.BASE_URL + '/deleteregistrationtype/' + Id
    );
  }
  deleteRegistrationDocument(Id: number) {
    let result: boolean;
    return this.http.delete(
      environment.BASE_URL + '/registration-document/' + Id
    );
  }
}
